<template>
  <div :class="$attrs.class">
    <label v-if="label" class="form-label" :for="id">{{ label }}:<span v-if="required"
        class="text-red-500">*</span></label>
    <div class="relative">
      <font-awesome-icon icon="fa-regular fa-calendar"
        class="cursor-pointer z-10 absolute top-1/2 transform -translate-y-1/2 left-3"
        @click="() => this.$refs.dateinput.openMenu()" />
      <input ref="input" v-mask="'##/##/####'" :id="id" v-bind="{ ...$attrs, class: null }" class="form-input pl-8"
        :class="{ error: error }" type="tel" :value="this.inputValue" @change="changeDate" @keyup="keyup"
        autocomplete="off" />
    </div>
    <Datepicker ref="dateinput" menuClassName="dp-custom-date" v-model="this.value" modelType="yyyy-MM-dd" weekStart="0"
      autoApply close-on-scroll :clearable="false" :format="format" :class="{ error: error }" :enableTimePicker="false"
      locale="pt-BR" @update:modelValue="onPickerUpdate">
      <template #dp-input="{ value, onInput, onEnter, onTab, onClear }">
      </template>
    </Datepicker>
    <div v-if="error" class="form-error">{{ error }}</div>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import ptBR from 'date-fns/locale/pt-BR';
import parse from 'date-fns/parse';
import format from 'date-fns/format';
import { mask, TheMask } from 'vue-the-mask'

export default {
  data() {
    return {
      value: null,
      inputValue: null,
    }
  },
  mounted() {
    /*
    if(this.modelValue) {
      this.value = this.modelValue;
      let date = this.modelValue.split('-').reverse().join('/');
      this.inputValue = date;
    }
    */
    this.fillValues(this.modelValue);
  },
  watch: {
    modelValue(valueNew, valueOld) {
      this.fillValues(this.modelValue);
    },
    value(valueNew, valueOld) {
      let modelValue = '';
      let modelInputValue = '';

      if (this.value) {
        modelValue = this.value;
        modelInputValue = this.value.split('-').reverse().join('/');
      }
      this.inputValue = modelInputValue;
      this.$emit('update:modelValue', modelValue);
    },
  },
  components: {
    Datepicker,
    ptBR,
    format,
    parse,
    TheMask,
  },
  directives: {
    mask
  },
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `text-input-${uuid()}`
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    error: String,
    label: String,
    modelValue: String,
    required: String,
  },
  emits: ['update:modelValue'],
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end)
    },
    format: (date) => format(date, 'dd/MM/yyyy'),
    keyup(input) {
      this.$refs.dateinput.closeMenu();
    },
    onPickerUpdate(newVal) {
      // Normaliza qualquer valor vindo do Datepicker para 'yyyy-MM-dd'
      if (!newVal) {
        this.value = null;
        return;
      }

      // Se já vier no formato desejado
      if (typeof newVal === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(newVal)) {
          this.value = newVal;
          return;
        }
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(newVal)) {
          const [d, m, y] = newVal.split('/');
          this.value = `${y}-${m}-${d}`;
          return;
        }
        const parsed = new Date(newVal);
        if (!isNaN(parsed)) {
          this.value = format(parsed, 'yyyy-MM-dd');
          return;
        }
        this.value = null;
        return;
      }

      // Se vier como Date
      if (newVal instanceof Date && !isNaN(newVal.getTime())) {
        this.value = format(newVal, 'yyyy-MM-dd');
        return;
      }

      // Fallback
      try {
        const parsed = new Date(newVal);
        if (!isNaN(parsed)) {
          this.value = format(parsed, 'yyyy-MM-dd');
        } else {
          this.value = null;
        }
      } catch (e) {
        this.value = null;
      }
    },
    fillValues(value) {
      if (value) {
        this.value = this.modelValue;
        let date = this.modelValue.split('-').reverse().join('/');
        this.inputValue = date;
      } else {
        this.value = null;
        this.inputValue = null;
      }
    },
    changeDate(input) {
      let date = input.target.value;
      let dateFormatted = date.split('/').reverse().join('-');
      if (dateFormatted.length == 10 && Date.parse(dateFormatted)) {
        this.value = dateFormatted;
      } else {
        input.target.value = '';
        this.value = null;
      }
    },
  },
}
</script>
<style>
.dp-custom-date .dp__overlay_cell_active,
.dp-custom-date .dp__active_date {
  background-color: var(--color-primary);
}
</style>
